import { createContext } from 'react';
import { GridOptions, defaultGridOptions } from './GridContext';

export const GridRefContext = createContext<{ current: GridOptions }>({
  current: defaultGridOptions,
});
